<template>

    <div class="shop::category-selector">

            <div class="text-gray-600 mb-1 label" v-if="label">{{ label }}</div>

            <treeselect
                ref="treeselect"
                :options="treeOptions"
                :name="name"
                v-model="internalValue"
                clearAllText="Verwijder allemaal"
                clearValueText="Verwijder"
                loadingText="Laden..."
                noChildrenText="Geen categorieeën"
                noOptionsText="Geen keuzes..."
                noResultsText="Geen keuzes..."
                placeholder="Kies categorie..."
                retryText="Probeer opnieuw"
                searchPromptText="Typ om te zoeken"
                :closeOnSelect="true"
                :multiple="false"
                search-nested
            >

                <template slot="option-label" slot-scope="{ node }">

                    <div
                        class="text-sm"
                        :class="{
                        'py-1': true,
                    }"
                    >
                        {{ node.raw.label }}
                    </div>

                </template>

                <div slot="value-label" slot-scope="{ node }">{{ node.raw.label }}</div>

            </treeselect>

    </div>

</template>

<script>

import axios from '@galaxy/modules/Core/resources/js/axiosBuilder';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

export default {

    components: {
        Treeselect,
    },

    props: {
        name: String,
        value: String,
        label: String,
    },

    data() {
        return {
            internalValue: null,
            categories: null,
        };
    },

    async mounted()
    {
        this.internalValue = this.value;

        await this.loadData();
    },

    methods: {

        async loadData() {
            // Load artists.
            this.categories = (await axios.get('/admin/modules/shop/categories/get-tree')).data;
        },

        mapItem(category, children) {
            // Abort due to no items? Otherwise Treeselect will show empty subtree.
            if (!children.length)
                return undefined;

            return _.map(children, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: support search & multi language.
                    children: this.mapItem( category, category.children ),
                };
            });
        },

    },

    computed: {

        treeOptions() {

            // Abort due to empty?
            if (this.categories === null)
                return [];

            // Map website pages.
            return _.map(this.categories, category => {
                return {
                    id: category.id,
                    label: category.name.nl, // TODO Medium: Add language support?
                    children: this.mapItem(category, category.children),
                };
            });
        },

    }

}

</script>

<style lang="scss">

// TODO High: Review, make it consistent with other elements in Galaxy. Why did we need so many custom CSS?
.shop\:\:category-selector {

    .vue-treeselect__control {
        @apply border-0 outline-none shadow-none flex relative p-0;
        box-shadow: none !important;
    }

    .vue-treeselect__input {
        @apply focus:border-indigo-500 focus:ring-indigo-500 bg-white text-base block border border-gray-300 rounded-md;
        border: 1px solid rgb(212, 212, 212) !important;
    }

    .vue-treeselect__single-value {
        padding: 2px 15px;
    }

    .vue-treeselect__control-arrow-container {
        @apply px-4 absolute right-0 top-[14px];
    }

    .vue-treeselect__option {
    }

    .vue-treeselect__label-container {
        @apply block;
        padding: 5px 15px !important;
    }

    .vue-treeselect--searchable .vue-treeselect__input-container {
        padding: 0;

        input {
            padding: 0 15px;
        }
    }
}

</style>
